/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TicketWorkOrderEventDto
 */
export interface TicketWorkOrderEventDto {
    /**
     * 
     * @type {string}
     * @memberof TicketWorkOrderEventDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TicketWorkOrderEventDto
     */
    eventType: TicketWorkOrderEventDtoEventTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TicketWorkOrderEventDto
     */
    actorId: string;
    /**
     * Display name of the actor (org or system user)
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    actorName?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof TicketWorkOrderEventDto
     */
    occurredAt: Date;
    /**
     * 
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    reason?: object | null;
    /**
     * 
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    workOrderId?: object | null;
    /**
     * Work order code linked to this event (when known)
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    workOrderCode?: object | null;
    /**
     * Source WO id for move/bundle/merge events
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    fromWorkOrderId?: object | null;
    /**
     * Source WO code for move/bundle/merge events
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    fromWorkOrderCode?: object | null;
    /**
     * Target WO id for move/bundle/merge events
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    toWorkOrderId?: object | null;
    /**
     * Target WO code for move/bundle/merge events
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    toWorkOrderCode?: object | null;
    /**
     * Visit execution result for COMPLETED ticket events (from event payload)
     * @type {string}
     * @memberof TicketWorkOrderEventDto
     */
    executionResult?: TicketWorkOrderEventDtoExecutionResultEnum | null;
    /**
     * Ticket status after this COMPLETED event (derived from executionResult)
     * @type {string}
     * @memberof TicketWorkOrderEventDto
     */
    ticketStatus?: TicketWorkOrderEventDtoTicketStatusEnum | null;
    /**
     * Whether the ticket needed follow-up after this COMPLETED event
     * @type {object}
     * @memberof TicketWorkOrderEventDto
     */
    needsFollowUp?: object | null;
    /**
     * Work order status before a STATUS_CHANGED transition
     * @type {string}
     * @memberof TicketWorkOrderEventDto
     */
    fromStatus?: TicketWorkOrderEventDtoFromStatusEnum | null;
    /**
     * Work order status after a STATUS_CHANGED transition
     * @type {string}
     * @memberof TicketWorkOrderEventDto
     */
    toStatus?: TicketWorkOrderEventDtoToStatusEnum | null;
}


/**
 * @export
 */
export const TicketWorkOrderEventDtoEventTypeEnum = {
    Created: 'CREATED',
    Assigned: 'ASSIGNED',
    Unassigned: 'UNASSIGNED',
    Bundled: 'BUNDLED',
    Unbundled: 'UNBUNDLED',
    Moved: 'MOVED',
    Started: 'STARTED',
    ReportSubmitted: 'REPORT_SUBMITTED',
    Completed: 'COMPLETED',
    WoCompleted: 'WO_COMPLETED',
    WoClosed: 'WO_CLOSED',
    Cancelled: 'CANCELLED',
    Archived: 'ARCHIVED',
    Reopened: 'REOPENED',
    StatusChanged: 'STATUS_CHANGED',
    WoMerged: 'WO_MERGED'
} as const;
export type TicketWorkOrderEventDtoEventTypeEnum = typeof TicketWorkOrderEventDtoEventTypeEnum[keyof typeof TicketWorkOrderEventDtoEventTypeEnum];

/**
 * @export
 */
export const TicketWorkOrderEventDtoExecutionResultEnum = {
    CompletedOk: 'COMPLETED_OK',
    CompletedWithIssue: 'COMPLETED_WITH_ISSUE',
    NotDone: 'NOT_DONE',
    Cancelled: 'CANCELLED'
} as const;
export type TicketWorkOrderEventDtoExecutionResultEnum = typeof TicketWorkOrderEventDtoExecutionResultEnum[keyof typeof TicketWorkOrderEventDtoExecutionResultEnum];

/**
 * @export
 */
export const TicketWorkOrderEventDtoTicketStatusEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Closed: 'CLOSED',
    Cancelled: 'CANCELLED'
} as const;
export type TicketWorkOrderEventDtoTicketStatusEnum = typeof TicketWorkOrderEventDtoTicketStatusEnum[keyof typeof TicketWorkOrderEventDtoTicketStatusEnum];

/**
 * @export
 */
export const TicketWorkOrderEventDtoFromStatusEnum = {
    Planned: 'PLANNED',
    Assigned: 'ASSIGNED',
    InProgress: 'IN_PROGRESS',
    OnHold: 'ON_HOLD',
    Completed: 'COMPLETED',
    Closed: 'CLOSED',
    Archived: 'ARCHIVED',
    Cancelled: 'CANCELLED'
} as const;
export type TicketWorkOrderEventDtoFromStatusEnum = typeof TicketWorkOrderEventDtoFromStatusEnum[keyof typeof TicketWorkOrderEventDtoFromStatusEnum];

/**
 * @export
 */
export const TicketWorkOrderEventDtoToStatusEnum = {
    Planned: 'PLANNED',
    Assigned: 'ASSIGNED',
    InProgress: 'IN_PROGRESS',
    OnHold: 'ON_HOLD',
    Completed: 'COMPLETED',
    Closed: 'CLOSED',
    Archived: 'ARCHIVED',
    Cancelled: 'CANCELLED'
} as const;
export type TicketWorkOrderEventDtoToStatusEnum = typeof TicketWorkOrderEventDtoToStatusEnum[keyof typeof TicketWorkOrderEventDtoToStatusEnum];


/**
 * Check if a given object implements the TicketWorkOrderEventDto interface.
 */
export function instanceOfTicketWorkOrderEventDto(value: object): value is TicketWorkOrderEventDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('actorId' in value) || value['actorId'] === undefined) return false;
    if (!('occurredAt' in value) || value['occurredAt'] === undefined) return false;
    return true;
}

export function TicketWorkOrderEventDtoFromJSON(json: any): TicketWorkOrderEventDto {
    return TicketWorkOrderEventDtoFromJSONTyped(json, false);
}

export function TicketWorkOrderEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketWorkOrderEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventType': json['eventType'],
        'actorId': json['actorId'],
        'actorName': json['actorName'] == null ? undefined : json['actorName'],
        'occurredAt': (new Date(json['occurredAt'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'workOrderId': json['workOrderId'] == null ? undefined : json['workOrderId'],
        'workOrderCode': json['workOrderCode'] == null ? undefined : json['workOrderCode'],
        'fromWorkOrderId': json['fromWorkOrderId'] == null ? undefined : json['fromWorkOrderId'],
        'fromWorkOrderCode': json['fromWorkOrderCode'] == null ? undefined : json['fromWorkOrderCode'],
        'toWorkOrderId': json['toWorkOrderId'] == null ? undefined : json['toWorkOrderId'],
        'toWorkOrderCode': json['toWorkOrderCode'] == null ? undefined : json['toWorkOrderCode'],
        'executionResult': json['executionResult'] == null ? undefined : json['executionResult'],
        'ticketStatus': json['ticketStatus'] == null ? undefined : json['ticketStatus'],
        'needsFollowUp': json['needsFollowUp'] == null ? undefined : json['needsFollowUp'],
        'fromStatus': json['fromStatus'] == null ? undefined : json['fromStatus'],
        'toStatus': json['toStatus'] == null ? undefined : json['toStatus'],
    };
}

export function TicketWorkOrderEventDtoToJSON(json: any): TicketWorkOrderEventDto {
    return TicketWorkOrderEventDtoToJSONTyped(json, false);
}

export function TicketWorkOrderEventDtoToJSONTyped(value?: TicketWorkOrderEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'eventType': value['eventType'],
        'actorId': value['actorId'],
        'actorName': value['actorName'],
        'occurredAt': value['occurredAt'].toISOString(),
        'reason': value['reason'],
        'workOrderId': value['workOrderId'],
        'workOrderCode': value['workOrderCode'],
        'fromWorkOrderId': value['fromWorkOrderId'],
        'fromWorkOrderCode': value['fromWorkOrderCode'],
        'toWorkOrderId': value['toWorkOrderId'],
        'toWorkOrderCode': value['toWorkOrderCode'],
        'executionResult': value['executionResult'],
        'ticketStatus': value['ticketStatus'],
        'needsFollowUp': value['needsFollowUp'],
        'fromStatus': value['fromStatus'],
        'toStatus': value['toStatus'],
    };
}

